import { AppService } from '../main/app.service';
import * as _ from "lodash";

export interface IGetList<TEntity> {
    size: number;
    value: TEntity[]
}

export interface IGetListParams {
    limit?: number;
    offset?: number;
    sortfield?: string;
    sortorder?: string;
    q?: string;
}

export class BaseService<TEntity> {

    public observerCallbacks: any = [];
    public collection: Restangular.ICollection = null;
    public list: Array<TEntity>;
    public item: TEntity;
    public itemId: string | number;

    constructor(protected Restangular: Restangular.IService, protected AppService: AppService, public itemName: string) {
        this.collection = Restangular.all(itemName);
    }

    public subscribe = (ctrlname, callback) => {
        this.observerCallbacks.push({ callback: callback, ctrl: ctrlname });

    }

    public unsubscribe = (ctrlname) => {
        _.remove(this.observerCallbacks, { ctrl: ctrlname })
    }

    public notifyObservers = (type) => {
        this.observerCallbacks.forEach(item => {
            item.callback(type);
        });
    };

    public one(id: string | number = null): Restangular.IElement {
        if (id) {
            return this.Restangular.one(this.itemName, id.toString());
        } else {
            return this.Restangular.one(this.itemName);
        }
    }

    public all = (params: IGetListParams = { 'limit': 5000 }): ng.IPromise<TEntity[]> => {
        return this.Restangular.all(this.itemName).customGET('', params).then((response: Restangular.ICollection) => {
            this.list = response.plain().value;
            return this.listLoaded(this.list);
        });
    }

    public listLoaded = (list: TEntity[]) => {
        return list;
    }

    public getList = (params: IGetListParams = { 'limit': 5000 }): ng.IPromise<IGetList<TEntity>> => {
        return this.Restangular.all(this.itemName).customGET('', params).then((response: Restangular.ICollection) => {
            return this.getListLoaded(response.plain());
        });
    }

    public getListLoaded = (collection: IGetList<TEntity>) => {
        return collection;
    }

    public customAll = (url, queryParams : {[key:string] : any} = { 'limit': 5000 }): ng.IPromise<TEntity[]> => {
        // console.log('customAll')
        return this.Restangular.all(this.itemName + '/' + url).getList(queryParams).then((list: Restangular.ICollection) => {
            this.list = list;
            return list.plain();
        });
    }

    public get(id: string | number): ng.IPromise<TEntity> {
        if (id) {
            return this.Restangular.one(this.itemName, id.toString()).get().then((item) => {
                this.item = item;
                return item.plain();
            });
        } else {
            this.item = null;
            return null;
        }
    }

    // public create(): Restangular.IElement {
    //     return this.Restangular.one(this.itemName);
    // }
    public delete(id: string | number): Restangular.IPromise<TEntity> {
        var promise = this.Restangular.one(this.itemName, id.toString()).remove();
        promise
            .then(result => {
                this.itemId = id;
                this.notifyObservers('delete');
                this.AppService.NotifyService.success('Verwijderd', 'De gegevens zijn verwijderd');
            })
            .catch(error => {
                this.AppService.NotifyService.error('Foutmelding', error.data);
            });
        return promise;
    }

    public post(data): ng.IPromise<TEntity> {
        return this.collection.post(data).then((item: Restangular.IElement) => {
            this.AppService.NotifyService.success('Opgeslagen', 'De gegevens zijn opgeslagen');
            this.item = item.plain();
            this.notifyObservers('post');
            return item.plain();
        })
            .catch((error) => {
                this.AppService.NotifyService.error('Foutmelding', error.data);
                return error;
            });
    }

    public customPost(url: string, data, displayResult: boolean = true): ng.IPromise<TEntity> {
        return this.collection.customPOST(data, url).then((item: Restangular.IElement) => {
            if (displayResult) {
                this.AppService.NotifyService.success('Opgeslagen', 'De gegevens zijn opgeslagen');
            }
            return item;
        })
            .catch((error) => {
                if (displayResult) {
                    this.AppService.NotifyService.error('Foutmelding', error.data);
                }
                return error;
            });
    }

    public put(id: string | number, data): Restangular.IPromise<TEntity> {
        var promise = this.Restangular.one(this.itemName, id.toString()).customPUT(data);
        promise
            .then(result => {
                this.AppService.NotifyService.success('Opgeslagen', 'De gegevens zijn opgeslagen');
                this.item = result.plain();
                this.notifyObservers('put');
            })
            .catch(error => {
                this.AppService.NotifyService.error('Foutmelding', error.data);
            });
        return promise;
    }

    public customPut(url: string, data): ng.IPromise<TEntity> {
        // console.log(data);
        return this.collection.customPUT(data, url).then((item: Restangular.IElement) => {
            this.AppService.NotifyService.success('Opgeslagen', 'De gegevens zijn opgeslagen');
            return item;
        })
            .catch((error) => {
                this.AppService.NotifyService.error('Foutmelding', error.data);
                return error;
            });
    }

    public customGet(url: string, params = null): ng.IPromise<TEntity> {
        return this.Restangular.one(this.itemName + '/' + url).get(params).then((item) => {
            if (item) {
                this.item = item;
                if (typeof item !== "string" && item.plain()) {
                    return item.plain();
                } else {
                    return item;
                }
            } else {
                return null;
            }
        });
    }

    public getChild(id: string | number, childName, params:IGetListParams = { 'limit': 5000 }): ng.IPromise<TEntity> {
        if ((typeof id === "number" && id > 0) || (typeof id === "string" && id !== undefined)) {
            return this.Restangular.one(this.itemName, id.toString()).customGET(childName, params).then((item) => {
                this.item = item.value;
                return item.value;
            });
        } else {
            this.item = null;
            return null;
        }
    }

    public postChild(data, parentId, childName): Restangular.IPromise<TEntity> {
        var promise = this.Restangular.one(this.itemName, parentId.toString()).customPOST(data, childName);

        promise
            .then(result => {
                this.AppService.NotifyService.success('Opgeslagen', 'De gegevens zijn opgeslagen');
            })
            .catch(error => {
                this.AppService.NotifyService.error('Foutmelding', error.data);
            });
        return promise;
    }

    public putChild(data, parentId, childName, childId): Restangular.IPromise<TEntity> {
        var promise = this.Restangular.one(this.itemName, parentId.toString()).customPUT(data, childName + '/' + childId);

        promise
            .then(result => {
                this.AppService.NotifyService.success('Opgeslagen', 'De gegevens zijn opgeslagen');
            })
            .catch(error => {
                this.AppService.NotifyService.error('Foutmelding', error.data);
            });
        return promise;
    }

    public deleteChild(childId, parentId, childName): Restangular.IPromise<TEntity> {
        var promise = this.Restangular.one(this.itemName, parentId.toString()).customDELETE(childName + '/' + childId);
        promise.then(result => {
            this.AppService.NotifyService.success('Verwijderd', 'De gegevens zijn verwijderd');
        })
            .catch(error => {
                this.AppService.NotifyService.error('Foutmelding', error.data);
            });
        return promise;
    }

    public customDelete(url: string): ng.IPromise<TEntity> {
        return this.collection.customDELETE(url).then((item: Restangular.IElement) => {
            this.AppService.NotifyService.success('Opgeslagen', 'De gegevens zijn opgeslagen');
            return item;
        })
            .catch((error) => {
                this.AppService.NotifyService.error('Foutmelding', error.data);
                return error;
            });
    }

    // public one(id: string | number = null): Restangular.IElement {
    //     if (id) {
    //         return this.Restangular.one(this.itemName, id.toString());
    //     } else {
    //         return this.Restangular.one(this.itemName);
    //     }
    // }

    // public listLoaded = () => {


    // }

}


// WEBPACK FOOTER //
// ./src/app/base/base.service.ts